import { hoursPerMonth, TB_TO_GB_MULTIPLIER } from '@siren-frontend/shared';

import { WorkloadSpec } from './common';

// hourly
const provisionedPricing = {
  wcu: 0.00065,
  rcu: 0.00013,
};

// per 1M ops
const onDemandPricing = {
  wcu: 0.625,
  rcu: 0.125,
};

const ThroughputAvgFactor = 0.33;
const storagePricing = 0.25; // GB/month

export function prices(workload: WorkloadSpec) {
  const wcu = Math.ceil(workload.itemSize) * workload.writes;
  const rcu = Math.ceil(workload.itemSize / 4) * workload.reads;
  const storage = workload.storage * TB_TO_GB_MULTIPLIER * storagePricing;

  const onDemand =
    (((rcu * onDemandPricing.rcu + wcu * onDemandPricing.wcu) *
      3600 *
      hoursPerMonth) /
      1e6) *
    ThroughputAvgFactor;
  const provisioned =
    (wcu * provisionedPricing.wcu + rcu * provisionedPricing.rcu) *
    hoursPerMonth;

  return [
    {
      id: 'dynamodb-on-demand',
      name: 'On Demand',
      total: storage + onDemand,
      storage,
      ops: onDemand,
      database: 'DynamoDB',
    },
    {
      id: 'dynamodb-provisioned',
      name: 'Provisioned',
      total: storage + provisioned,
      storage,
      ops: provisioned,
      database: 'DynamoDB',
    },
  ];
}
